import { useTranslation } from 'gatsby-plugin-react-i18next';
import { PageSliceType } from '@contracts';

const USP1 = 'https://ecommerce-website.cdn.prismic.io/ecommerce-website/780f85aa-1d7f-4d7d-a502-ea9bbccd71e3_productsUSP1.svg';
const USP2 = 'https://ecommerce-website.cdn.prismic.io/ecommerce-website/e3056a14-58b4-45c0-9853-45b483af11b0_productsUSP2.svg';
const USP3 = 'https://ecommerce-website.cdn.prismic.io/ecommerce-website/b0e214cf-9577-4892-a19b-556516346134_productsUSP3.svg';

export const getUSPData = () => {
  const { t } = useTranslation();

  const productsUSPData = {
    slice_type: PageSliceType.IconTextGrid,
    primary: {
      gap: { text: '60px' },
      padding: { text: '40px' },
      alignment_desktop: 'image-text-vertical',
      alignment_mobile: 'image-text-vertical',
      background_color: '#F1F6E4',
      background_gradient: { text: '' },
      column_max_width: { text: '315px' },
      columns: { text: '2' },
      grid_title: { richText: '' },
      image_height: { text: '70px' },
      image_width: { text: '70px' },
      text_color: '#003B1B'
    },
    items: [
      {
        image: {
          gatsbyImageData: {
            images: {
              sources: [],
              fallback: {
                src: USP2
              }
            },
            layout: 'constrained',
            width: 70,
            height: 70
          },
          alt: ''
        },
        text: {
          html: `<span class="heading-5">${t('components.sub-and-save').toUpperCase()}</span><p>${t('components.receive-products')}</p`
        }
      },
      {
        image: {
          gatsbyImageData: {
            images: {
              sources: [],
              fallback: {
                src: USP1
              }
            },
            layout: 'constrained',
            width: 70,
            height: 70
          },
          alt: ''
        },
        link: { text: 'https://yourdaye.zendesk.com/hc/en-us' },
        link_text: { text: `${t('components.help-center-link')}` },
        type_of_link: 'internal',
        text: {
          html: `<span class="heading-5">${t('components.subscribe-tampons-satisfaction').toUpperCase()}</span><p>${t(
            'components.contact-customer-care'
          )}</p`
        }
      },
      {
        image: {
          gatsbyImageData: {
            images: {
              sources: [],
              fallback: {
                src: USP3
              }
            },
            layout: 'constrained',
            width: 70,
            height: 70
          },
          alt: ''
        },
        // link: { text: '/' },
        // link_text: { text: `${t('components.shipping-information')}` },
        // type_of_link: 'internal',
        text: {
          html: `<span class="heading-5">${t('components.carbon-neutral-delivery').toUpperCase()}</span><p>${t(
            'components.offset-carbon-footprint'
          )}</p`
        }
      }
    ]
  };

  return productsUSPData;
};
